import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  page: 1,
  limit: 10,
  total: 0,
  totalPages: 0,
};

export const leadProposalPaginateSlice = createSlice({
  name: "leadProposalPaginate",
  initialState,
  reducers: {
    setCurrentPage: (state, action) => {
      state.page = action.payload;
    },
    setPageLimit: (state, action) => {
      state.limit = action.payload;
    },
    setTotalCount: (state, action) => {
      state.total = action.payload;
    },
    setTotalPages: (state, action) => {
      state.totalPages = action.payload;
    },
    resetPagination: (state) => {
      state.page = 1;
      state.limit = 10;
      state.total = 0;
      state.totalPages = 0;
    },
  },
});

export const {
  setCurrentPage,
  setPageLimit,
  setTotalCount,
  setTotalPages,
  resetPagination,
} = leadProposalPaginateSlice.actions;

export default leadProposalPaginateSlice.reducer;